import { FC } from 'react'
import { useTranslation } from 'next-i18next'
import styles from './index.module.scss'
import { IJobBase } from '../../../types'
import { NoContent } from '../../atoms/NoContent'
import { PrimaryHeadingWithLink } from '../../atoms/PrimaryHeadingWithLink'
import { CompanyProfileJobItem } from '../../molecules/CompanyProfileJobItem'

type Props = {
  jobs: IJobBase[]
  companySlug: string
}

export const CompanyProfileJobs: FC<Props> = ({ jobs, companySlug }) => {
  const { t } = useTranslation(['jobs'])
  return (
    <div className={styles.container}>
      <div className={styles.heading}>
        <PrimaryHeadingWithLink htmlTagType='h2' href={`/companies/${companySlug}/jobs`}>
          {t('求人')}
        </PrimaryHeadingWithLink>
      </div>
      <div>
        {jobs?.length === 0 ? (
          <NoContent>{t('求人はまだ掲載されていません。')}</NoContent>
        ) : (
          jobs?.map((job) => {
            return (
              <div className={styles.jobItem} key={job.id}>
                <CompanyProfileJobItem job={job} />
              </div>
            )
          })
        )}
      </div>
    </div>
  )
}
